import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeRedoDocumentMetadata } from "../../domain/use-cases/redo-document-metadata"
import { httpDocumentRepository } from "../../data/repositories/document-repository"

const redoDocumentMetadata = makeRedoDocumentMetadata(httpDocumentRepository)

export const useRedoDocumentMetadata = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (docId: string) => redoDocumentMetadata(docId),
    onSuccess: (_, docId) => {
      qc.invalidateQueries({ queryKey: ["document", docId] })
      qc.invalidateQueries({ queryKey: ["documents"] })
    },
  })
}
